import {getColorScheme} from '@linx-security/ui/theme';

import {defineNodePartsStyleConfig} from './config';
import {$borderColor} from './css-vars';

const style = defineNodePartsStyleConfig(({colorScheme, style}) => {
  const scheme = getColorScheme(colorScheme, [`yellow`, `green`, `red`, `gray`]).value;

  return {
    container: {
      fontFamily: `mono`,
      textTransform: `uppercase`,
      // Changing those variables changes the handles as well
      ...scheme,
      [$borderColor.variable]: style?.borderColor ?? scheme.borderColor,
    },
    tagline: {
      display: `none`,
    },
  };
});

export default style;
